export const marketPlaceOffer = 'marketPlace';
export const stockEasyOffer = 'stockEasy';
export const pickingOffer = 'picking';
export const statisticsOffer = 'statistics';
